import { Box, Grid } from "@material-ui/core";
import { Style } from "./MainStyles";
import * as FileSaver from "file-saver";
import { FC, ReactNode, lazy, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Route, Switch, useHistory, useLocation } from "react-router-dom";
import routes from "../../Router/Router";
import { pathNames } from "../../Seo";
import { GetAllCars, GetProfileInfo } from "../../Store/Slices/CommonDataSlice";
import ToolbarForm from "../Toolbar/Toolbar";
import ConfigurationServices from "../../Services/Configuration/ConfigurationServices";

const Footer = lazy(() => import("../Footer/Footer"));
interface IProps {
  children?: ReactNode;
}

const Main: FC<IProps> = () => {
  const dispatch = useDispatch();
  const [token] = useState(localStorage.getItem("manaToken"));
  const history = useHistory();
  const { search } = useLocation();
  const pathname = history.location.pathname;
  const [isMainPage, setIsMainPage] = useState(true);
  const [infos, setInfos] = useState<any>([]);
  const classes = Style();

  function seo(data: any = []) {
    const tab = data.filter((d: any) => d.url === window.location.pathname);
    if (search === "?login") {
      document.title = "ورود به سامانه | سیگما";
      document
        ?.querySelector('meta[name="description"]')
        ?.setAttribute("content", "ورود به سامانه | سیگما");
    } else {
      if (!!tab && tab.length > 0) {
        document.title = tab[0].title;
        document
          ?.querySelector('meta[name="description"]')
          ?.setAttribute("content", tab[0].title);
      }
    }
  }
  const srch = useLocation().search;
  const searchParams = new URLSearchParams(srch);
  useEffect(() => {
    ConfigurationServices.GetWebInfos({ pn: "1", pl: "1000" }, (res) => {
      if (res.status == "0") {
        setInfos(res.infos.filter((i: any) => i.popup === "1"));
      }
    });
  }, []);
  useEffect(() => {
    if (!!searchParams) {
      const newRefChannel: any =
        !!searchParams && !!searchParams.get("ref")
          ? searchParams.get("ref")
          : "";
      if (!!newRefChannel) {
        localStorage.setItem("referralChannel", newRefChannel);
      }
    }
  }, [searchParams]);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [history.location.pathname]);
  useEffect(() => {
    setIsMainPage(history.location.pathname === "/");
    seo(pathNames);
  }, [window?.location?.pathname]);
  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 500);
  }, []);
  useEffect(() => {
    dispatch(GetAllCars());
    if (token != null && !!token && token != undefined) {
      dispatch(GetProfileInfo());
    }
  }, []);
  useEffect(() => {}, [isMainPage]);
  return (
    <>
      <div
        style={{
          minHeight: "100vh",
          padding: "0",
          zIndex: 1,
          overflow: "hidden",
        }}
      >
        <div id="goftino_div_id"></div>
        <div
          style={{ direction: "rtl", minHeight: "100vh", position: "relative" }}
        >
          <div>
            <div
              className="row justify-content-center ml-0 mr-0"
              style={{
                // position: 'absolute',
                width: "100%",
              }}
            >
              <ToolbarForm />
            </div>
          </div>
          <Box
            sx={{
              marginTop: { xs: "80px", sm: "80px", md: "130px", lg: "130px" },
            }}
          >
            <Switch>
              {routes.map((route, index) => {
                return (
                  <Route
                    exact
                    path={route.path}
                    key={index}
                    component={route.component}
                  />
                );
              })}
            </Switch>
          </Box>
          {pathname === "/" ||
          pathname === "/prchs-cntnt" ||
          pathname === "/sls-cntnt" ||
          pathname === "/about-us" ||
          pathname === "/contact-us" ||
          pathname === "/faq" ||
          pathname === "/rules" ||
          pathname === "/privacy" ||
          pathname === "/mana-forms" ||
          pathname === "/sug" ? (
            <>{search !== "?login" ? <Footer /> : ""}</>
          ) : (
            ""
          )}
        </div>
        {infos.length === 0 ? "" : " "}
      </div>
      {pathname === "/" && (
        <div
          onClick={() => history.push("/info")}
          className={classes.loadspeaker}
        >
          <img
            width="46px"
            src={process.env.PUBLIC_URL + "/images/loadspeaker.png"}
          />
        </div>
      )}
    </>
  );
};

export default Main;
